import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedModule } from "app/shared/shared.module";
import { EmptyLayoutComponent } from "app/layout/layouts/empty/empty.component";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";

@NgModule({
  declarations: [EmptyLayoutComponent],
  imports: [RouterModule, FuseLoadingBarComponent, SharedModule],
  exports: [EmptyLayoutComponent],
})
export class EmptyLayoutModule {}
